import { render, staticRenderFns } from "./TotalArticles.vue?vue&type=template&id=3702c090&scoped=true"
import script from "./TotalArticles.vue?vue&type=script&lang=js"
export * from "./TotalArticles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702c090",
  null
  
)

export default component.exports